// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-outline-primary {
  color: #83a4cf;
  border-color: #83a4cf;
}

.btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:visited,
.btn-outline-primary:active,
.btn-check:checked + .btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check) + .btn:active {
  /* background-color: #83A4CF; */
  color: #fff;
}

.bg-white {
  background-color: #fff;
}

.mainDiv {
  /* margin-top:80px; */
}

.widget_kratos {
  /* background: #CDDAEA; */
  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
  border-radius: 5px;
}

.widget_Kratos {
  background: #cddaea;
}

.widgetIcon img {
  width: 50px;
  height: 50px;
}

.widgetIcon-32 img {
  width: 32px;
  height: 32px;
}

.titlebg_kratos {
  font-size: 1em;
  color: #0e3157;
  font-weight: 600;
  /* margin-bottom: 10px; */
  text-align: center;
  background: #e0e0e0;
  border-radius: 5px 5px 0 0;
  /* margin-top: -12px;
    margin-left: -10px;
    margin-right: -10px; */
}

/* .chartbox {
    background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 5px 10px;
    color: #353535;
    min-height: 255px;
    border-radius: 5px;
} */

.chartHGT_Kratos {
  padding: 10px;
}

h5,
.h5 {
  font-size: 1.1rem !important;
}

p {
  line-height: 1rem !important;
}

small,
.small {
  font-size: 80% !important;
}

table tr td {
  font-size: 0.8em;
}

.accordion-button_kratos {
  font-size: 0.5em;
  background-color: #fff;
}

.accordion-button_kratos:focus {
  /* background-color: rgb(255, 255, 255, 1) !important; */
  background-color: #fff !important;
  box-shadow: inset 0 -1px 0 #fff !important;
  /* box-shadow: inset 0 -1px 0 rgb(255, 255, 255, 1) !important; */
}

.accordion-button_kratos:not(.collapsed) {
  /* background-color:#e0e0e0; */
  background-color: rgb(179, 177, 177) !important;
  color: #222;
}

/* .filterForm>.form-label {
    font-size: 0.825em;
} */

/* .form-label {
    font-size: 0.825em;
} */

.Headfont {
  font-size: 1.8rem;
}

.dropdown-menu[data-bs-popper] {
  right: 0 !important;
  left: auto;
}

/******************** 17042023 *********************/
.nav-link {
  font-size: 0.85em !important;
}

.nav-link {
  font-size: 0.85em !important;
  color: #000 !important;
}

.navbar-nav .nav-link.active,
.navbar-nav .show > .nav-link {
  /* color: var(--bs-navbar-active-color); */
  color: #ffffff !important;
  background-color: #83a4cf;
  border-radius: 20px;
  padding: 5px 10px;
  text-align: center;
}

.kratos_nav_icon {
  font-size: 14px;
}

/* .btn-primary{
	background-color: #83A4CF !important;
    border-color: #83A4CF !important;
} */
.txtColor,
p {
  color: #0e3157;
}

.mainDiv_kratos {
  margin-top: 15px;
}

body {
  /* background-color: #F2F3FC !important; */
}

.cardBox > .card {
}

.cardBox > .card > .card-body {
  padding: 5px !important;
}

/***************************** PageTwo *******************************/
.bt-graph {
  border-right: solid 1px #b5b5b5;
}

.headBG {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #83a4cf;
  border-radius: 5px;
}

/* media queries start here */

@media (min-width: 836px) {
  .navbar-expand-sm {
    flex-wrap: nowrap !important;
    justify-content: flex-start !important;
  }
}

@media screen and (max-width: 740px) {
  .titlebg {
    font-size: 0.9em;
  }
}

@media screen and (max-width: 720px) {
  .mainDiv {
    /* margin-top:124px; */
  }
}

@media screen and (max-width: 480px) {
  .mainDiv {
    /* margin-top:155px; */
  }
}

@media screen and (max-width: 480px) {
  .topHeader h2 {
    font-size: 22px;
    padding-right: 3rem;
  }

  .titlebg {
    font-size: 0.9em;
  }
}

@media screen and (max-width: 320px) {
  .topHeader h2 {
    font-size: 16px;
    padding-right: 0rem;
  }
}

/*---------------------------*/

body {
  margin: 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  width: 100%;
  height: 100%;
  /* background-color: #F5F5F5 !important; */
}

.bg-theme {
  background: #358696 !important;
  box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);
}

/* .headFont{ */
/* font-size: 26px; font-weight: 600; margin-left: 55px; color: #fff; */
/* } */
.nav-link {
  font-size: 0.85em !important;
  color: #000 !important;
}

.navbar-nav .nav-link.active,
.navbar-nav .show > .nav-link {
  /* color: var(--bs-navbar-active-color); */
  color: #ffffff !important;
  background-color: #83a4cf;
  border-radius: 20px;
  padding: 5px 10px;
  text-align: center;
}

.kratos_nav_icon {
  font-size: 14px;
}

/********* Landing 2 Starts ********/
.dashboard_card {
  font-size: 1.1em;
  color: #000;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: 0.5s;
  background: #fff;
  border: solid 1px #c3c3c3;
  box-shadow: 1px 1px 25px #33333320;
  padding: 45px 15px 45px 15px;
  margin-top: 20px;
  width: 100%;
}

.dashboard_card img {
  width: 50px;
}

.dashboard_card span {
  display: block;
  padding-top: 15px;
  font-weight: 600;
  line-height: 25px;
}

.dashboard_card:hover {
  box-shadow: 1px 1px 25px #999;
}

/********* Media Queries Starts ********/

@media (min-width: 836px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}

@media screen and (max-width: 991px) {
}

@media screen and (max-width: 769px) {
}

@media screen and (max-width: 420px) {
}

/****************CSS Chnaged*********************/
.titlebg strong {
  position: absolute;
  top: 3px;
  right: 8px;
}

.titlebg_ev strong {
  position: absolute;
  top: 5px;
  right: 23px;
}

.text-fit {
  padding: 9px;
}

.FilterDiv_kratos {
  background: #fff;
}

.chartbox_kratos {
  padding: 0px;
}

.FilterDiv_kratos {
  background-color: #f8f9fa !important;
  /* margin-bottom: -16px !important; */
}

.btn_kratos {
  background-color: #83a4cf !important;
}

.filter_kratos_icon {
  background: #83a4cf !important;
}

.card_kratos {
  border: 1px solid #83a4cf;
}

.back_chng {
  background: #e0e0e0;
}

.kratosflt {
  border: 1px solid #a5b0a9 !important;
  border-radius: 6px;
}

.kratosdrpg1 {
  background-color: #f2f3fc !important;
  /* margin: -3px; */
}

.kratos_tkps {
  padding: 0px 12px;
}

.titlebg .tlbg_kratos {
  right: 30px !important;
}

.kratos_bg_c {
  /* background-color: #F5F5F5; */
}

/*******************CSS ENd***********************/

/* #F5F5F5 */
/* #F2F3FC */
/* added code for filters */
.kratos_filtr_btn .btn-primary {
  background-color: #83a4cf !important;
  border-color: #83a4cf !important;
}
.kratos_filtr_btn .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:visited,
.btn:active,
.btn:target {
  background-color: #83a4cf;
  border-color: #83a4cf;
}

/* .btn:hover, */

.form-label_kratos {
  /* color: #83a4cf !important; */
  background: transparent;
  padding: 0px !important;
  text-align: left;
  margin-bottom: 0px !important;
  color: #83a4cf !important;
  font-weight: 600;
  display: block;
}
.select_col_title_kratos {
  background: transparent;
  padding: 0px !important;
  text-align: left;
  margin-bottom: 0px !important;
  color: #83a4cf !important;
  font-weight: 600;
  display: block;
}
.row.equal-cols {
  display: flex;
  flex-wrap: wrap;
}

.row.equal-cols:before,
.row.equal-cols:after {
  display: block;
}

.row.equal-cols > [class*="col-"] {
  display: flex;
  flex-direction: column;
}

.row.equal-cols > [class*="col-"] > * {
  flex: 1 1 auto;
}
.kratos .form-check-input:checked {
  background-color: #83a4cf;
  border-color: #83a4cf96;
}
.filter_kratos_icon_f .btn:hover {
  color: #fff !important;
  background-color: #83a4cf96 !important;
  border-color: #83a4cf96 !important;
}
.titlebg_kratos1 {
  font-size: 1em;
  color: #0e3157;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
  background: #fff;
  border-radius: 5px 5px 0 0;
  margin-top: -12px;
  margin-left: -10px;
  margin-right: -10px !important;
}
.monthclass {
  float: right;
}
.row {
  /* margin-right: -14px; */
}
dl dt.red_kratos {
  background: #5579a6;
}

dl dt.yellow_kratos {
  background: #83a4cf;
}

.kratos_filtr_btn .rca_btn_kratos {
  background-color: #ffa650 !important;
}

.kratos_filtr_btn .rca_btn_kratos:hover {
  background-color: #fcb877 !important;
  border-color: #fcb877 !important;
}

.btn_drive {
  background-color: #83a4cf !important;
  border-color: #83a4cf !important;
}

.btn_drive:hover {
  background-color: #83a4cf !important;
  border-color: #83a4cf !important;
}

.btn_drive:focus,
.btn_drive:focus-visible,
.btn_drive:focus-within,
.btn_drive:hover,
.btn_drive:visited,
.btn_drive:active,
.btn_drive:target {
  background-color: #83a4cf !important;
  border-color: #83a4cf !important;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.react-datepicker-wrapper {
  /* position: relative; */
  margin-left: -9px;
  /* visibility: hidden !important; */
}

.drive_last {
  padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Kratos/Driveanalysis_Kratos/Driveanalysis_Kratos.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;;;;;;EASE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B;;0BAEwB;AAC1B;;AAEA;;;;;;;GAOG;;AAEH;EACE,aAAa;AACf;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;EACxD,iCAAiC;EACjC,0CAA0C;EAC1C,iEAAiE;AACnE;;AAEA;EACE,8BAA8B;EAC9B,+CAA+C;EAC/C,WAAW;AACb;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,oDAAoD;AACpD;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;GAGG;AACH;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;AACA;;AAEA;EACE,uBAAuB;AACzB;;AAEA,sEAAsE;AACtE;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6BAA6B;;AAE7B;EACE;IACE,4BAA4B;IAC5B,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,8BAA8B;;AAE9B;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA,eAAe;AACf,uEAAuE;AACvE,MAAM;AACN;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,wCAAwC;;AAExC;EACE;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;AACF;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kDAAkD;;AAElD,YAAY;AACZ,YAAY;AACZ,2BAA2B;AAC3B;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gBAAgB;;AAEhB;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EAGE,aAAa;EAGb,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EAGE,aAAa;EAGb,sBAAsB;AACxB;;AAEA;EAGE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;;;;EAOE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf","sourcesContent":[".btn-outline-primary {\n  color: #83a4cf;\n  border-color: #83a4cf;\n}\n\n.btn-outline-primary:hover,\n.btn-outline-primary:focus,\n.btn-outline-primary:visited,\n.btn-outline-primary:active,\n.btn-check:checked + .btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check) + .btn:active {\n  /* background-color: #83A4CF; */\n  color: #fff;\n}\n\n.bg-white {\n  background-color: #fff;\n}\n\n.mainDiv {\n  /* margin-top:80px; */\n}\n\n.widget_kratos {\n  /* background: #CDDAEA; */\n  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n  border-radius: 5px;\n}\n\n.widget_Kratos {\n  background: #cddaea;\n}\n\n.widgetIcon img {\n  width: 50px;\n  height: 50px;\n}\n\n.widgetIcon-32 img {\n  width: 32px;\n  height: 32px;\n}\n\n.titlebg_kratos {\n  font-size: 1em;\n  color: #0e3157;\n  font-weight: 600;\n  /* margin-bottom: 10px; */\n  text-align: center;\n  background: #e0e0e0;\n  border-radius: 5px 5px 0 0;\n  /* margin-top: -12px;\n    margin-left: -10px;\n    margin-right: -10px; */\n}\n\n/* .chartbox {\n    background: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 5px 10px;\n    color: #353535;\n    min-height: 255px;\n    border-radius: 5px;\n} */\n\n.chartHGT_Kratos {\n  padding: 10px;\n}\n\nh5,\n.h5 {\n  font-size: 1.1rem !important;\n}\n\np {\n  line-height: 1rem !important;\n}\n\nsmall,\n.small {\n  font-size: 80% !important;\n}\n\ntable tr td {\n  font-size: 0.8em;\n}\n\n.accordion-button_kratos {\n  font-size: 0.5em;\n  background-color: #fff;\n}\n\n.accordion-button_kratos:focus {\n  /* background-color: rgb(255, 255, 255, 1) !important; */\n  background-color: #fff !important;\n  box-shadow: inset 0 -1px 0 #fff !important;\n  /* box-shadow: inset 0 -1px 0 rgb(255, 255, 255, 1) !important; */\n}\n\n.accordion-button_kratos:not(.collapsed) {\n  /* background-color:#e0e0e0; */\n  background-color: rgb(179, 177, 177) !important;\n  color: #222;\n}\n\n/* .filterForm>.form-label {\n    font-size: 0.825em;\n} */\n\n/* .form-label {\n    font-size: 0.825em;\n} */\n\n.Headfont {\n  font-size: 1.8rem;\n}\n\n.dropdown-menu[data-bs-popper] {\n  right: 0 !important;\n  left: auto;\n}\n\n/******************** 17042023 *********************/\n.nav-link {\n  font-size: 0.85em !important;\n}\n\n.nav-link {\n  font-size: 0.85em !important;\n  color: #000 !important;\n}\n\n.navbar-nav .nav-link.active,\n.navbar-nav .show > .nav-link {\n  /* color: var(--bs-navbar-active-color); */\n  color: #ffffff !important;\n  background-color: #83a4cf;\n  border-radius: 20px;\n  padding: 5px 10px;\n  text-align: center;\n}\n\n.kratos_nav_icon {\n  font-size: 14px;\n}\n\n/* .btn-primary{\n\tbackground-color: #83A4CF !important;\n    border-color: #83A4CF !important;\n} */\n.txtColor,\np {\n  color: #0e3157;\n}\n\n.mainDiv_kratos {\n  margin-top: 15px;\n}\n\nbody {\n  /* background-color: #F2F3FC !important; */\n}\n\n.cardBox > .card {\n}\n\n.cardBox > .card > .card-body {\n  padding: 5px !important;\n}\n\n/***************************** PageTwo *******************************/\n.bt-graph {\n  border-right: solid 1px #b5b5b5;\n}\n\n.headBG {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #83a4cf;\n  border-radius: 5px;\n}\n\n/* media queries start here */\n\n@media (min-width: 836px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap !important;\n    justify-content: flex-start !important;\n  }\n}\n\n@media screen and (max-width: 740px) {\n  .titlebg {\n    font-size: 0.9em;\n  }\n}\n\n@media screen and (max-width: 720px) {\n  .mainDiv {\n    /* margin-top:124px; */\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .mainDiv {\n    /* margin-top:155px; */\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .topHeader h2 {\n    font-size: 22px;\n    padding-right: 3rem;\n  }\n\n  .titlebg {\n    font-size: 0.9em;\n  }\n}\n\n@media screen and (max-width: 320px) {\n  .topHeader h2 {\n    font-size: 16px;\n    padding-right: 0rem;\n  }\n}\n\n/*---------------------------*/\n\nbody {\n  margin: 0px;\n  padding: 0px;\n  font-family: \"Open Sans\", sans-serif;\n  width: 100%;\n  height: 100%;\n  /* background-color: #F5F5F5 !important; */\n}\n\n.bg-theme {\n  background: #358696 !important;\n  box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);\n}\n\n/* .headFont{ */\n/* font-size: 26px; font-weight: 600; margin-left: 55px; color: #fff; */\n/* } */\n.nav-link {\n  font-size: 0.85em !important;\n  color: #000 !important;\n}\n\n.navbar-nav .nav-link.active,\n.navbar-nav .show > .nav-link {\n  /* color: var(--bs-navbar-active-color); */\n  color: #ffffff !important;\n  background-color: #83a4cf;\n  border-radius: 20px;\n  padding: 5px 10px;\n  text-align: center;\n}\n\n.kratos_nav_icon {\n  font-size: 14px;\n}\n\n/********* Landing 2 Starts ********/\n.dashboard_card {\n  font-size: 1.1em;\n  color: #000;\n  font-weight: 600;\n  text-align: center;\n  cursor: pointer;\n  transition: 0.5s;\n  background: #fff;\n  border: solid 1px #c3c3c3;\n  box-shadow: 1px 1px 25px #33333320;\n  padding: 45px 15px 45px 15px;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.dashboard_card img {\n  width: 50px;\n}\n\n.dashboard_card span {\n  display: block;\n  padding-top: 15px;\n  font-weight: 600;\n  line-height: 25px;\n}\n\n.dashboard_card:hover {\n  box-shadow: 1px 1px 25px #999;\n}\n\n/********* Media Queries Starts ********/\n\n@media (min-width: 836px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n}\n\n@media screen and (max-width: 991px) {\n}\n\n@media screen and (max-width: 769px) {\n}\n\n@media screen and (max-width: 420px) {\n}\n\n/****************CSS Chnaged*********************/\n.titlebg strong {\n  position: absolute;\n  top: 3px;\n  right: 8px;\n}\n\n.titlebg_ev strong {\n  position: absolute;\n  top: 5px;\n  right: 23px;\n}\n\n.text-fit {\n  padding: 9px;\n}\n\n.FilterDiv_kratos {\n  background: #fff;\n}\n\n.chartbox_kratos {\n  padding: 0px;\n}\n\n.FilterDiv_kratos {\n  background-color: #f8f9fa !important;\n  /* margin-bottom: -16px !important; */\n}\n\n.btn_kratos {\n  background-color: #83a4cf !important;\n}\n\n.filter_kratos_icon {\n  background: #83a4cf !important;\n}\n\n.card_kratos {\n  border: 1px solid #83a4cf;\n}\n\n.back_chng {\n  background: #e0e0e0;\n}\n\n.kratosflt {\n  border: 1px solid #a5b0a9 !important;\n  border-radius: 6px;\n}\n\n.kratosdrpg1 {\n  background-color: #f2f3fc !important;\n  /* margin: -3px; */\n}\n\n.kratos_tkps {\n  padding: 0px 12px;\n}\n\n.titlebg .tlbg_kratos {\n  right: 30px !important;\n}\n\n.kratos_bg_c {\n  /* background-color: #F5F5F5; */\n}\n\n/*******************CSS ENd***********************/\n\n/* #F5F5F5 */\n/* #F2F3FC */\n/* added code for filters */\n.kratos_filtr_btn .btn-primary {\n  background-color: #83a4cf !important;\n  border-color: #83a4cf !important;\n}\n.kratos_filtr_btn .btn:focus,\n.btn:focus-visible,\n.btn:focus-within,\n.btn:visited,\n.btn:active,\n.btn:target {\n  background-color: #83a4cf;\n  border-color: #83a4cf;\n}\n\n/* .btn:hover, */\n\n.form-label_kratos {\n  /* color: #83a4cf !important; */\n  background: transparent;\n  padding: 0px !important;\n  text-align: left;\n  margin-bottom: 0px !important;\n  color: #83a4cf !important;\n  font-weight: 600;\n  display: block;\n}\n.select_col_title_kratos {\n  background: transparent;\n  padding: 0px !important;\n  text-align: left;\n  margin-bottom: 0px !important;\n  color: #83a4cf !important;\n  font-weight: 600;\n  display: block;\n}\n.row.equal-cols {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.row.equal-cols:before,\n.row.equal-cols:after {\n  display: block;\n}\n\n.row.equal-cols > [class*=\"col-\"] {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.row.equal-cols > [class*=\"col-\"] > * {\n  -webkit-flex: 1 1 auto;\n  -ms-flex: 1 1 auto;\n  flex: 1 1 auto;\n}\n.kratos .form-check-input:checked {\n  background-color: #83a4cf;\n  border-color: #83a4cf96;\n}\n.filter_kratos_icon_f .btn:hover {\n  color: #fff !important;\n  background-color: #83a4cf96 !important;\n  border-color: #83a4cf96 !important;\n}\n.titlebg_kratos1 {\n  font-size: 1em;\n  color: #0e3157;\n  font-weight: 600;\n  margin-bottom: 10px;\n  text-align: center;\n  background: #fff;\n  border-radius: 5px 5px 0 0;\n  margin-top: -12px;\n  margin-left: -10px;\n  margin-right: -10px !important;\n}\n.monthclass {\n  float: right;\n}\n.row {\n  /* margin-right: -14px; */\n}\ndl dt.red_kratos {\n  background: #5579a6;\n}\n\ndl dt.yellow_kratos {\n  background: #83a4cf;\n}\n\n.kratos_filtr_btn .rca_btn_kratos {\n  background-color: #ffa650 !important;\n}\n\n.kratos_filtr_btn .rca_btn_kratos:hover {\n  background-color: #fcb877 !important;\n  border-color: #fcb877 !important;\n}\n\n.btn_drive {\n  background-color: #83a4cf !important;\n  border-color: #83a4cf !important;\n}\n\n.btn_drive:hover {\n  background-color: #83a4cf !important;\n  border-color: #83a4cf !important;\n}\n\n.btn_drive:focus,\n.btn_drive:focus-visible,\n.btn_drive:focus-within,\n.btn_drive:hover,\n.btn_drive:visited,\n.btn_drive:active,\n.btn_drive:target {\n  background-color: #83a4cf !important;\n  border-color: #83a4cf !important;\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.react-datepicker-wrapper {\n  /* position: relative; */\n  margin-left: -9px;\n  /* visibility: hidden !important; */\n}\n\n.drive_last {\n  padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
